/*
 * elova-scroll-reveal.js
 *
 * Progressive-enhancement fallback for browsers WITHOUT
 * `animation-timeline: view()` support (Safari, Firefox pre-view()).
 * In supported browsers (Chrome / Edge / Chromium 115+), the elova-*
 * sections handle their own scroll reveals natively via
 * `animation-timeline: view()` — this file is a no-op.
 *
 * When view() is unsupported, this observer adds the `.elova-revealed`
 * class to any element carrying `.elova-reveal` when it enters the
 * viewport, triggering the CSS transition defined in elova-tokens.css
 * under `@supports not (animation-timeline: view())`.
 *
 * Respects prefers-reduced-motion — no observer created, elements are
 * visible from first paint via the CSS reset in the same @media block.
 *
 * Loaded deferred from theme/layout/theme.liquid.
 */

(() => {
  // Feature detection: if the browser natively supports view() timelines,
  // the elova-* sections' own reveals do the work. Do nothing here.
  if (window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()')) {
    return;
  }

  // Respect reduced-motion preference — CSS keeps content statically
  // visible for these users; no observer needed.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const start = () => {
    const targets = document.querySelectorAll('.elova-reveal:not(.elova-revealed)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      // Very old browser: reveal everything immediately, no motion.
      targets.forEach((el) => el.classList.add('elova-revealed'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('elova-revealed');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach((el) => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
